import styled from 'styled-components'

export const PageView = styled.div`
  min-height: 95vh;
  padding: 20px;
  margin-top: 24px;
  position: relative;

  ${(p) => p.theme.media.mobile_xs} {
    padding: 10px;
  }
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 35px;
  color: #323a43;

  ${(p) => p.theme.media.mobile_xs} {
    font-size: 25px;
  }
`

export const Desc = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #323a43;
  padding-top: 10px;
  margin-bottom: 30px;
`

export const Phone = styled.div`
  width: 100%;
`

export const ButtonStyled = styled.div`
  width: 100%;
  margin-top: 120px;
`

export const Btn = styled.div`
  width: 240px;
  margin: 0 auto;
`

export const LinkInvalid = styled.div`
  color: ${(p) => p.theme.color.error};
  margin-top: 4px;
  font-size: 14px;
  text-align: left;

  a {
    color: ${(p) => p.theme.color.blue};
    font-weight: 600;
    padding: 0px 4px;
  }
`
